// -------------------首页底部折叠--------------------
document.addEventListener("DOMContentLoaded", function () {
  // 只在手机端执行
  if (window.innerWidth <= 768) {
    const footerButtons = document.querySelectorAll(".newfooterbtn");

    footerButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        const widget = btn.closest(".widget");

        // 切换 open 类
        widget.classList.toggle("open");
      });
    });
  }
});

// -----------------------首页评分去掉“reviews”，并给数量添加（）------------------
// document.addEventListener('DOMContentLoaded', function () {

//   function updateJudgeReview() {

//     document.querySelectorAll(' .featured-collection__collection .columns .jdgm-prev-badge__text').forEach(function (el) {

//       let text = el.textContent.trim();

//       let match = text.match(/(\d+)\s*reviews?/i);

//       if (match) {
//         el.textContent = '(' + match[1] + ')';
//       }

//     });

//   }


//   // 页面第一次执行
//   updateJudgeReview();


//   // 监听 Judge.me 后续重新渲染
//   const observer = new MutationObserver(function () {
//     updateJudgeReview();
//   });


//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     characterData: true
//   });

// });

// ---------------详情页评论图当打关闭后页面滚动问题-------------------
(function () {
  // 防止脚本重复执行
  if (window.__jdgmReviewScrollFixInitialized) return;
  window.__jdgmReviewScrollFixInitialized = true;

  let popupOpen = false;
  let restoreTimer = null;

  const html = document.documentElement;
  const body = document.body;

  function disableSmoothScroll() {
    html.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );

    body.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );
  }

  function restoreSmoothScroll() {
    html.style.removeProperty('scroll-behavior');
    body.style.removeProperty('scroll-behavior');
  }

  // Judge.me 评论图片点击
  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest(
        'a.jdgm-rev__pic-link'
      );

      if (!link) return;

      // 清除之前的恢复计时器
      clearTimeout(restoreTimer);

      // Popup 打开前就关闭 smooth scroll
      disableSmoothScroll();

      console.log(
        '[Judge.me] smooth scroll disabled'
      );
    },
    true
  );

  // 监听 Judge.me Popup 状态
  const observer = new MutationObserver(function () {
    const isOpen =
      body.classList.contains('jm-mfp-is-open');

    // Popup 打开
    if (isOpen) {
      popupOpen = true;

      // 防止 Judge.me 打开过程中其他代码覆盖
      disableSmoothScroll();

      return;
    }

    // Popup 刚刚关闭
    if (popupOpen) {
      popupOpen = false;

      console.log(
        '[Judge.me] popup closed'
      );

      /*
       * Judge.me 关闭 Popup 后还会执行
       * afterClose / scroll restoration。
       *
       * 所以这里不要立即恢复 smooth，
       * 给 Judge.me 留一点时间完成关闭流程。
       */
      clearTimeout(restoreTimer);

      restoreTimer = setTimeout(function () {
        restoreSmoothScroll();

        console.log(
          '[Judge.me] smooth scroll restored'
        );
      }, 500);
    }
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
  });
})();


// ---------------img link模块滑动模式下拖拽功能--------------
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.NewImgoverbtn .NewImgBox').forEach(function (slider) {
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let hasMoved = false;

      slider.addEventListener('mousedown', function (e) {
        isDragging = true;
        hasMoved = false;

        startX = e.pageX - slider.offsetLeft;
        startScrollLeft = slider.scrollLeft;

        slider.style.cursor = 'grabbing';

        e.preventDefault();
      });

      slider.addEventListener('mousemove', function (e) {
        if (!isDragging) return;

        const x = e.pageX - slider.offsetLeft;
        const distance = x - startX;

        if (Math.abs(distance) > 5) {
          hasMoved = true;
        }

        slider.scrollLeft = startScrollLeft - distance;
      });

      slider.addEventListener('mouseup', function () {
        isDragging = false;
        slider.style.cursor = 'grab';
      });

      slider.addEventListener('mouseleave', function () {
        isDragging = false;
        slider.style.cursor = 'grab';
      });

      // 阻止拖动后的a标签跳转
      slider.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (hasMoved) {
            e.preventDefault();
          }
        });
      });
    });
  });
// -----------------------------------------


// ---------------------------库存动态更新--------------------------
document.addEventListener("DOMContentLoaded", function () {
  const stockBoxes = document.querySelectorAll("[data-new-stock-box]");

  if (!stockBoxes.length) return;

  // 1 小时
  const ONE_HOUR = 60 * 60 * 1000;

  const STORAGE_KEY = "shopify_sold_percent_data";

  /**
   * 读取 localStorage
   */
  function getStorage() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (error) {
      return {};
    }
  }
 
  /**
   * 保存 localStorage
   */
  function saveStorage(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      // localStorage 不可用时，不影响页面其他功能
    }
  }

  /**
   * 更新 Sold 百分比显示
   */
  function updateDisplay(box, percent) {
    const bar = box.querySelector("[data-new-stock-bar]");
    const text = box.querySelector("[data-new-stock-text]");

    if (!bar || !text) return;

    bar.style.width = percent + "%";
    text.textContent = "Sold " + percent + "%";

    // 清除旧状态
    bar.classList.remove("low", "critical", "newstockout");
    text.classList.remove("low", "critical", "newstockout");

    // 根据 Sold 百分比添加状态 class
    if (percent >= 80) {
      bar.classList.add("newstockout");
      text.classList.add("newstockout");
    } else if (percent >= 50) {
      bar.classList.add("critical");
      text.classList.add("critical");
    } else {
      bar.classList.add("low");
      text.classList.add("low");
    }
  }

  /**
   * 更新单个商品的 Sold 状态
   */
  function updateProduct(box, storage) {
    const productId = box.dataset.productId;
    const initialPercent = parseInt(box.dataset.stockPercent, 10);

    if (!productId || isNaN(initialPercent)) return false;

    let productData = storage[productId];

    // 第一次进入
    if (!productData) {
      productData = {
        initialPercent: initialPercent,
        currentPercent: initialPercent,
        lastUpdate: Date.now()
      };

      storage[productId] = productData;

      updateDisplay(box, productData.currentPercent);

      return true;
    }

    // Shopify 后台修改了 new_stock 初始值
    if (productData.initialPercent !== initialPercent) {
      productData = {
        initialPercent: initialPercent,
        currentPercent: initialPercent,
        lastUpdate: Date.now()
      };

      storage[productId] = productData;

      updateDisplay(box, productData.currentPercent);

      return true;
    }

    // 计算距离上次减少经过了多少时间
    const now = Date.now();
    const elapsed = now - productData.lastUpdate;

    const decreaseCount = Math.floor(elapsed / ONE_HOUR);

    // 到达减少时间
    if (decreaseCount > 0) {
      let currentPercent =
        productData.currentPercent - decreaseCount;

      // 到 1 后重新从初始值开始
      if (currentPercent < 1) {
        currentPercent = productData.initialPercent;
      }

      productData.currentPercent = currentPercent;

      // 保留未使用的时间
      productData.lastUpdate += decreaseCount * ONE_HOUR;

      storage[productId] = productData;

      updateDisplay(box, currentPercent);

      return true;
    }

    // 没有变化，只更新当前显示
    updateDisplay(box, productData.currentPercent);

    return false;
  }

  /* 初始化所有商品 */
  let storage = getStorage();
  let storageChanged = false;

  stockBoxes.forEach(function (box) {
    const changed = updateProduct(box, storage);

    if (changed) {
      storageChanged = true;
    }
  });

  if (storageChanged) {
    saveStorage(storage);
  }

  /* 定期检查，每分钟检查一次，真正的减少时间是通过 Date.now()计算，即使页面关闭、刷新，也不会丢失时间。*/
  setInterval(function () {
    let storage = getStorage();
    let changed = false;

    stockBoxes.forEach(function (box) {
      const productChanged = updateProduct(box, storage);

      if (productChanged) {
        changed = true;
      }
    });

    if (changed) {
      saveStorage(storage);
    }
  }, 60 * 1000);
});

// -----------------------------------------

// 手机端导航交互
(() => {
const initMenu = () => {
const menu = document.querySelector(
".style3-menu_m .thb-full-menu"
);

if (!menu || menu.dataset.centerMenuInit === "true") return;

menu.dataset.centerMenuInit = "true";

const mediaQuery = window.matchMedia("(max-width: 1067px)");

// 获取一级菜单项
const getMenuItems = () =>
  Array.from(menu.querySelectorAll(":scope > li"));

// 统一 URL 格式，忽略末尾斜杠和查询参数
const normalizeUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    return (
      parsed.origin +
      parsed.pathname.replace(/\/+$/, "")
    );
  } catch (e) {
    return "";
  }
};

// 将当前 li 平滑滚动到菜单中间
const centerItem = (li, behavior = "smooth") => {
  if (!mediaQuery.matches || !li) return;

  const menuRect = menu.getBoundingClientRect();
  const liRect = li.getBoundingClientRect();

  const offset =
    liRect.left +
    liRect.width / 2 -
    (menuRect.left + menu.clientWidth / 2);

  const maxScroll = menu.scrollWidth - menu.clientWidth;

  const targetScroll = Math.max(
    0,
    Math.min(menu.scrollLeft + offset, maxScroll)
  );

  menu.scrollTo({
    left: targetScroll,
    behavior
  });
};

// 恢复当前页面对应的选中项
const restoreSelectedItem = () => {
  if (!mediaQuery.matches) return;

  const currentUrl = normalizeUrl(window.location.href);
  const items = getMenuItems();

  // 优先匹配当前页面 URL
  let selectedItem = items.find((li) => {
    const link = li.querySelector(":scope > .NewOneA");

    return (
      link &&
      normalizeUrl(link.href) === currentUrl
    );
  });

  // URL 未匹配时，使用 Shopify 当前页面标记
  if (!selectedItem) {
    const activeLink = menu.querySelector(
      ':scope > li > .NewOneA[aria-current="page"]'
    );

    selectedItem =
      activeLink?.parentElement ||
      menu.querySelector(":scope > li.active");
  }

  // 统一选中状态
  items.forEach((li) => {
    li.classList.toggle(
      "is-selected",
      li === selectedItem
    );
  });

  // 页面加载后将当前分类居中
  if (selectedItem) {
    centerItem(selectedItem, "auto");
  }
};

// 点击一级菜单：立即切换下划线并居中
menu.addEventListener("click", (event) => {
  if (!mediaQuery.matches) return;

  const link = event.target.closest(".NewOneA");

  // 只处理一级菜单的直接链接
  if (
    !link ||
    !menu.contains(link) ||
    link.parentElement.parentElement !== menu
  ) {
    return;
  }

  const li = link.parentElement;

  // 立即更新选中状态
  getMenuItems().forEach((item) => {
    item.classList.toggle(
      "is-selected",
      item === li
    );
  });

  // 平滑滚动到菜单中间
  centerItem(li, "smooth");

  // 不阻止默认行为，保留原有链接跳转
});

// 首次布局完成后恢复状态
requestAnimationFrame(() => {
  requestAnimationFrame(restoreSelectedItem);
});

// 切换到手机宽度时重新定位
mediaQuery.addEventListener("change", (event) => {
  if (event.matches) {
    requestAnimationFrame(restoreSelectedItem);
  }
});

};

if (document.readyState === "loading") {
document.addEventListener(
"DOMContentLoaded",
initMenu,
{ once: true }
);
} else {
initMenu();
}
})();